import React from 'react';
import classnames from 'classnames';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import SubscribersOnly from '../../_partials/SubscribersOnly';
import CommentButton from '../../buttons/CommentButton';
import FavouriteButton from '../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import EditButton from '../../buttons/EditButton';
import EditBackgroundButton from '../../buttons/EditBackgroundButton';
import DeleteButton from '../../buttons/DeleteButton';
import TheaterButton from '../../buttons/TheaterButton';
import ExpandButton from '../../buttons/ExpandButton';
import TierButton from '../../buttons/TierButton';
import s from './TierActionBar.scss';
export const TierActionBar = ({ deviation , isOwner , className  })=>{
    const { hasMoreActions , isCommentable , isEditable , isDeletable , isFavouritable , isGroupSubmittable , isBackgroundEditable  } = useDeviationAttributes(deviation, isOwner);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['indicators']
    }, /*#__PURE__*/ React.createElement(SubscribersOnly, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['actions']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['main-actions']
    }, isFavouritable && /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    }), isCommentable && /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        // TODO: this is a hack to show the 'comment' label because we have the space, owner or not
        isOwner: false,
        actionBarType: "primary"
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['extra-actions']
    }, isGroupSubmittable && /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation,
        actionBarType: "primary"
    }), !isOwner && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            referral_info: ReferralType.TIER_UNIQUE
        }
    }, /*#__PURE__*/ React.createElement(TierButton, {
        deviation: deviation,
        className: s['subscribe-button']
    })), hasMoreActions && /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    }), isBackgroundEditable && /*#__PURE__*/ React.createElement(EditBackgroundButton, {
        deviation: deviation
    }), isDeletable && /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    }), isEditable && /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['view-controls']
    }, /*#__PURE__*/ React.createElement(TheaterButton, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(ExpandButton, {
        deviation: deviation
    })));
};
TierActionBar.displayName = 'TierActionBar';
export default TierActionBar;
